import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX, NOTE_TEMPLATE_API_PREFIX } from '../utils/constants';

export interface NoteTemplate {
    id: number;
    name: string;
    category: string;
    template: string;
    created_at?: string;
    updated_at?: string;
}

export interface ListNoteTemplatesResponse {
    note_templates: NoteTemplate[];
    total_count: number;
    limit: number;
    offset: number;
    status: string;
}

export const getNoteTemplatesList = async (
    search?: string,
    limit: number = 10,
    offset: number = 0
): Promise<ListNoteTemplatesResponse> => {
    try {
        const params: Record<string, any> = { limit, offset };
        if (search) { params.name = search; }

        const { data } = await axiosInstance.get(
            `${API_V1_PREFIX}${NOTE_TEMPLATE_API_PREFIX}`,
            { params }
        );

        return data;
    } catch (error: any) {
        throw new Error(error?.message || 'Failed to fetch note templates list');
    }
};

export const getNoteTemplateById = async (
    id: number
): Promise<NoteTemplate & { status: string }> => {
    try {
        const { data } = await axiosInstance.get(
            `${API_V1_PREFIX}${NOTE_TEMPLATE_API_PREFIX}${id}`
        );

        return data;
    } catch (error: any) {
        if (error.response?.data?.description) {
            throw new Error(error.response.data.description);
        }
        throw new Error(error?.message || 'Failed to fetch note template details');
    }
};

export const createNoteTemplate = async (
    newTemplate: Omit<NoteTemplate, 'id'>
): Promise<{ id: number; status: string }> => {
    try {
        const { data } = await axiosInstance.post(
            `${API_V1_PREFIX}${NOTE_TEMPLATE_API_PREFIX}`,
            newTemplate
        );

        return data;
    } catch (error: any) {
        if (error.response?.data?.description) {
            throw new Error(error.response.data.description);
        }
        throw new Error(error?.message || 'Failed to create note template');
    }
};

export const updateNoteTemplate = async (
    template: NoteTemplate
): Promise<{ status: string }> => {
    try {
        const { data } = await axiosInstance.patch(
            `${API_V1_PREFIX}${NOTE_TEMPLATE_API_PREFIX}`,
            template
        );

        return data;
    } catch (error: any) {
        if (error.response?.data?.description) {
            throw new Error(error.response.data.description);
        }
        throw new Error(error?.message || 'Failed to update note template');
    }
};

export const deleteNoteTemplate = async (
    id: number
): Promise<{ id: number; status: string; message: string }> => {
    try {
        const { data } = await axiosInstance.delete(
            `${API_V1_PREFIX}${NOTE_TEMPLATE_API_PREFIX}`,
            { data: { id } }
        );

        return data;
    } catch (error: any) {
    
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error(error?.message || 'Failed to delete note template');
    }
};
